import request from '@/utils/request'

/**
 * 获取异常处理文件列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fileExceptionPrtscreenListGet(data) {
  return request({
    type: 'device',
    url: 'file/exception/prtscreen/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/File.js